// app.menu.ts
import { IMenuItem } from "@models/menu-item.model";
import { ROLE_GROUPS } from "./roles";

export const menuItems: IMenuItem[] = [
  {
    label: "Dashboard",
    icon: "home",
    route: "/",
  },
  {
    label: "BI Dashboard",
    icon: "dashboard",
    route: "/bi",
  },
  {
    label: "Dashboard Demo",
    icon: "home",
    route: "/demo",
  },
  {
    label: "Organization",
    icon: "business",
    route: "/organization",
    requiredRoles: ROLE_GROUPS.ADMIN_ROLES,
  },
  {
    label: 'MIPS Attest',
    icon: 'assignment',
    route: '/mipsattest',
  },
    {
    label: "Issue Tracker",
    icon: "bug_report",
    route: "/issueTracker",
  },
  {
    label: "Information Hub",
    icon: "sms",
    route: "/information-hub",
  },
  {
    label: "Schedule/Run Reports",
    icon: "assessment",
    route: "/reporting",
  },
  {
    label: "MIPS File Repository",
    icon: "folder_open",
    route: "/mips-file-repository",
    requiredRoles: ROLE_GROUPS.SUPER_USER,
  },
  {
    label: "User Admin",
    icon: "manage_accounts",
    route: "/useradmin",
    requiredRoles: ROLE_GROUPS.ADMIN_ROLES
  },
  {
    label: "Admin Hub",
    icon: "settings",
    route: "/admin-hub",
    requiredRoles: ROLE_GROUPS.SUPER_USER,
  },
  // {
  //   label: "Organization Admin",
  //   icon: "business",
  //   route: "/organizationadmin",
  //   requiredRoles: ROLE_GROUPS.SUPER_USER_ONLY
  // },
];
